module.exports = __webpack_public_path__ + "img/5_fineTeam_js.4ec81315.png";